/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateThermoformingBaseDto } from '../../models/create-thermoforming-base-dto';
import { ThermoformingBase } from '../../models/thermoforming-base';

export interface CreateOneBaseMgmtThermoformingBaseControllerThermoformingBase$Params {
      body: CreateThermoformingBaseDto
}

export function createOneBaseMgmtThermoformingBaseControllerThermoformingBase(http: HttpClient, rootUrl: string, params: CreateOneBaseMgmtThermoformingBaseControllerThermoformingBase$Params, context?: HttpContext): Observable<StrictHttpResponse<ThermoformingBase>> {
  const rb = new RequestBuilder(rootUrl, createOneBaseMgmtThermoformingBaseControllerThermoformingBase.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ThermoformingBase>;
    })
  );
}

createOneBaseMgmtThermoformingBaseControllerThermoformingBase.PATH = '/api/mgmt/thermoforming-base';
